import { numberFormat } from '@/utils/unitUtils';

export const CHART_COLORS = ['#B6E0EA', '#6EC1E4', '#0A2F5C'];

export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 40,
    },
  },
  plugins: {
    legend: { position: 'top' },
    yAxisLabel: { enabled: true },
    tooltip: {
      enabled: true,
      mode: 'index',
      intersect: false,
      callbacks: {
        label: context => {
          return `${context.dataset.label}: ${numberFormat(context.parsed.y, 3)}`;
        },
      },
    },
  },
  scales: {
    x: { stacked: true },
    y: { stacked: true },
  },
};
